/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadScreenerLeadInfoRace } from './LeadScreenerLeadInfoRace';
import {
    LeadScreenerLeadInfoRaceFromJSON,
    LeadScreenerLeadInfoRaceFromJSONTyped,
    LeadScreenerLeadInfoRaceToJSON,
    LeadScreenerLeadInfoRaceToJSONTyped,
} from './LeadScreenerLeadInfoRace';
import type { LeadScreenerLeadInfoState } from './LeadScreenerLeadInfoState';
import {
    LeadScreenerLeadInfoStateFromJSON,
    LeadScreenerLeadInfoStateFromJSONTyped,
    LeadScreenerLeadInfoStateToJSON,
    LeadScreenerLeadInfoStateToJSONTyped,
} from './LeadScreenerLeadInfoState';

/**
 * 
 * @export
 * @interface LeadScreenerLeadInfo
 */
export interface LeadScreenerLeadInfo {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    s3_photo_key?: string | null;
    /**
     * 
     */
    photo_url?: string;
    /**
     * 
     */
    marital_status?: LeadScreenerLeadInfoMaritalStatusEnum;
    /**
     * 
     */
    primary_language?: string | null;
    /**
     * 
     */
    phone_number?: string;
    /**
     * 
     */
    email?: string;
    /**
     * 
     */
    contact_method_preference?: LeadScreenerLeadInfoContactMethodPreferenceEnum;
    /**
     * 
     */
    current_address?: string;
    /**
     * 
     */
    state_id?: string;
    /**
     * 
     */
    race_id?: string;
    /**
     * 
     */
    religion?: LeadScreenerLeadInfoReligionEnum;
    /**
     * 
     */
    race?: LeadScreenerLeadInfoRace;
    /**
     * 
     */
    state?: LeadScreenerLeadInfoState;
}


/**
 * @export
 */
export const LeadScreenerLeadInfoMaritalStatusEnum = {
    Single: 'single',
    DomesticPartner: 'domestic_partner',
    Married: 'married',
    Separated: 'separated',
    Divorced: 'divorced',
    Widowed: 'widowed',
    UnknownDeclined: 'unknown_declined',
} as const;
export type LeadScreenerLeadInfoMaritalStatusEnum = typeof LeadScreenerLeadInfoMaritalStatusEnum[keyof typeof LeadScreenerLeadInfoMaritalStatusEnum];

/**
 * @export
 */
export const LeadScreenerLeadInfoContactMethodPreferenceEnum = {
    Email: 'Email',
    Text: 'Text',
    Call: 'Call',
    Other: 'Other',
} as const;
export type LeadScreenerLeadInfoContactMethodPreferenceEnum = typeof LeadScreenerLeadInfoContactMethodPreferenceEnum[keyof typeof LeadScreenerLeadInfoContactMethodPreferenceEnum];

/**
 * @export
 */
export const LeadScreenerLeadInfoReligionEnum = {
    _7thDayAdventist: '7th Day Adventist',
    Atheist: 'Atheist',
    Agnostic: 'Agnostic',
    Apolistic: 'Apolistic',
    Apostolic: 'Apostolic',
    AssemblyOfGod: 'Assembly of God',
    Baptist: 'Baptist',
    Buddhist: 'Buddhist',
    Catholic: 'Catholic',
    Congregational: 'Congregational',
    Christian: 'Christian',
    ChristianScientist: 'Christian Scientist',
    ChurchOfChrist: 'Church of Christ',
    ChristianMissionaryAlliance: 'Christian Missionary Alliance',
    ChurchOfTheNazarene: 'Church of the Nazarene',
    ChristianReformed: 'Christian Reformed',
    Covenant: 'Covenant',
    DisciplesOfChrist: 'Disciples of Christ',
    Episcopalian: 'Episcopalian',
    Evangelical: 'Evangelical',
    FirstAssembly: 'First Assembly',
    GreekOrthodox: 'Greek Orthodox',
    Hinduism: 'Hinduism',
    Islam: 'Islam',
    Judaism: 'Judaism',
    JehovahsWitness: 'Jehovah\'s Witness',
    Lutheran: 'Lutheran',
    ChurchOfTheLatterDaySaints: 'Church of the Latter Day Saints',
    Methodist: 'Methodist',
    Mennonite: 'Mennonite',
    Mormon: 'Mormon',
    Moravian: 'Moravian',
    None: 'None',
    NonDenominational: 'Non-Denominational',
    Orthodox: 'Orthodox',
    Protestant: 'Protestant',
    Pentecostal: 'Pentecostal',
    Presbyterian: 'Presbyterian',
    Quaker: 'Quaker',
    Scientology: 'Scientology',
    Taoist: 'Taoist',
    Traditional: 'Traditional',
    Unitarian: 'Unitarian',
    Unknown: 'Unknown',
} as const;
export type LeadScreenerLeadInfoReligionEnum = typeof LeadScreenerLeadInfoReligionEnum[keyof typeof LeadScreenerLeadInfoReligionEnum];


/**
 * Check if a given object implements the LeadScreenerLeadInfo interface.
 */
export function instanceOfLeadScreenerLeadInfo(value: object): value is LeadScreenerLeadInfo {
    return true;
}

export function LeadScreenerLeadInfoFromJSON(json: any): LeadScreenerLeadInfo {
    return LeadScreenerLeadInfoFromJSONTyped(json, false);
}

export function LeadScreenerLeadInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadScreenerLeadInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        's3_photo_key': json['s3_photo_key'] === undefined ? undefined : json['s3_photo_key'] === null ? null : json['s3_photo_key'],
        'photo_url': json['photo_url'] == null ? undefined : json['photo_url'],
        'marital_status': json['marital_status'] == null ? undefined : json['marital_status'],
        'primary_language': json['primary_language'] === undefined ? undefined : json['primary_language'] === null ? null : json['primary_language'],
        'phone_number': json['phone_number'] == null ? undefined : json['phone_number'],
        'email': json['email'] == null ? undefined : json['email'],
        'contact_method_preference': json['contact_method_preference'] == null ? undefined : json['contact_method_preference'],
        'current_address': json['current_address'] == null ? undefined : json['current_address'],
        'state_id': json['state_id'] == null ? undefined : json['state_id'],
        'race_id': json['race_id'] == null ? undefined : json['race_id'],
        'religion': json['religion'] == null ? undefined : json['religion'],
        'race': json['race'] == null ? undefined : LeadScreenerLeadInfoRaceFromJSON(json['race']),
        'state': json['state'] == null ? undefined : LeadScreenerLeadInfoStateFromJSON(json['state']),
    };
}

export function LeadScreenerLeadInfoToJSON(json: any): LeadScreenerLeadInfo {
    return LeadScreenerLeadInfoToJSONTyped(json, false);
}

export function LeadScreenerLeadInfoToJSONTyped(value?: LeadScreenerLeadInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        's3_photo_key': value['s3_photo_key'],
        'photo_url': value['photo_url'],
        'marital_status': value['marital_status'],
        'primary_language': value['primary_language'],
        'phone_number': value['phone_number'],
        'email': value['email'],
        'contact_method_preference': value['contact_method_preference'],
        'current_address': value['current_address'],
        'state_id': value['state_id'],
        'race_id': value['race_id'],
        'religion': value['religion'],
        'race': LeadScreenerLeadInfoRaceToJSON(value['race']),
        'state': LeadScreenerLeadInfoStateToJSON(value['state']),
    };
}

